/* 787 Coffee — motion runtime (port of components/motion.tsx + ink.tsx).
   All motion is CSS; this file only toggles classes. Reduced motion → finished state immediately. */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var P7 = (window.P7 = window.P7 || {});

  /* ---- Reveal ---------------------------------------------------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.is-in):not([data-reveal-bound])');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    function make(opts) {
      var io = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var t = e.target;
          // Stagger children count from 0 within each batch that comes into view together, so a card far
          // down a grid waits for its row, not its position in the whole list (card 20 used to wait 1.7s).
          if (t.hasAttribute('data-stagger-i')) t.style.setProperty('--i', String((parseInt(t.getAttribute('data-stagger-s') || '0', 10)) + n++));
          t.classList.add('is-in'); io.unobserve(t);
        });
      }, opts);
      return io;
    }
    var io, early;
    els.forEach(function (el) {
      el.setAttribute('data-reveal-bound', '');
      // Product grid cards start just before they scroll into view, so they are already in place on arrival.
      if (el.hasAttribute('data-stagger-i') && el.parentElement && el.parentElement.classList.contains('p7-grid')) {
        (early = early || make({ threshold: 0, rootMargin: '0px 0px 8% 0px' })).observe(el);
      } else {
        (io = io || make({ threshold: 0.18, rootMargin: '0px 0px -6% 0px' })).observe(el);
      }
    });
  }

  /* ---- Stagger: add .reveal + --i to direct children ------------------- */
  function initStagger(root) {
    (root || document).querySelectorAll('[data-stagger]:not([data-stagger-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-stagger-bound', '');
      var v = wrap.getAttribute('data-stagger') || 'up';
      var start = parseInt(wrap.getAttribute('data-stagger-start') || '0', 10);
      // data-stagger-fold: children already on screen when the script boots stay as rendered (no hide, no fade),
      // so the first row of a product grid shows the moment the HTML paints.
      var fold = wrap.hasAttribute('data-stagger-fold') ? window.innerHeight : -1;
      var hidden = [];
      Array.prototype.forEach.call(wrap.children, function (child, i) {
        if (fold > 0 && child.getBoundingClientRect().top < fold) return;
        // Already painted, so drop to the hidden start state instantly instead of fading out first.
        child.style.transition = 'none';
        hidden.push(child);
        child.classList.add('reveal');
        child.setAttribute('data-stagger-i', '');
        if (start) child.setAttribute('data-stagger-s', String(start));
        if (v !== 'up') child.setAttribute('data-v', v);
        child.style.setProperty('--i', String(start + i));
      });
      if (hidden.length) { void wrap.offsetWidth; hidden.forEach(function (c) { c.style.transition = ''; }); }
    });
  }

  /* ---- Split words ----------------------------------------------------- */
  function splitWords(el) {
    if (el.hasAttribute('data-split-done')) return;
    el.setAttribute('data-split-done', '');
    var accent = (el.getAttribute('data-accent') || '').toLowerCase().split('|').filter(Boolean);
    var accentClass = el.getAttribute('data-accent-class') || 'c-guava';
    var text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    el.classList.add('split-words');
    var frag = document.createDocumentFragment();
    text.split(/\s+/).forEach(function (word, i) {
      var w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span'); inner.textContent = word; inner.style.setProperty('--i', String(i));
      var bare = word.toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
      if (accent.length && accent.some(function (a) { return a.replace(/[^\p{L}\p{N}]/gu, '') === bare; })) inner.classList.add(accentClass);
      w.appendChild(inner); frag.appendChild(w);
      if (i < 1e9) frag.appendChild(document.createTextNode(' '));
    });
    el.textContent = ''; el.appendChild(frag);
    if (REDUCED) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  }
  function initSplit(root) { (root || document).querySelectorAll('[data-split]').forEach(splitWords); }

  /* ---- Ink draw-on ----------------------------------------------------- */
  function initInk(root) {
    var els = (root || document).querySelectorAll('.ink:not(.is-drawn):not([data-ink-bound])');
    if (!els.length) return;
    if (REDUCED) { els.forEach(function (el) { el.classList.add('is-drawn'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-drawn'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    els.forEach(function (el) { el.setAttribute('data-ink-bound', ''); io.observe(el); });
  }

  /* ---- Counter --------------------------------------------------------- */
  function initCounter(root) {
    (root || document).querySelectorAll('[data-count]:not([data-count-bound])').forEach(function (el) {
      el.setAttribute('data-count-bound', '');
      var to = parseFloat(el.getAttribute('data-count'));
      var prefix = el.getAttribute('data-prefix') || '', suffix = el.getAttribute('data-suffix') || '';
      var sep = el.getAttribute('data-sep') !== 'false';
      var fmt = function (n) { var s = Math.round(n).toString(); return prefix + (sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : s) + suffix; };
      if (REDUCED || isNaN(to)) { el.textContent = fmt(to); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return; io.disconnect();
          var t0 = performance.now(), dur = 1400;
          (function step(t) { var p = Math.min(1, (t - t0) / dur); var ease = 1 - Math.pow(1 - p, 3); el.textContent = fmt(to * ease); if (p < 1) requestAnimationFrame(step); })(t0);
        });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  /* ---- Tilt ------------------------------------------------------------ */
  function initTilt(root) {
    if (REDUCED) return;
    (root || document).querySelectorAll('.tilt:not([data-tilt-bound])').forEach(function (el) {
      el.setAttribute('data-tilt-bound', '');
      var max = parseFloat(el.getAttribute('data-tilt-max') || '6');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * max) + 'deg) rotateY(' + (x * max) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---- Parallax -------------------------------------------------------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length || REDUCED) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(); var speed = parseFloat(el.getAttribute('data-parallax') || '0.1');
        var center = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-center * speed).toFixed(1) + 'px,0)';
      });
    }
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    var pw = document.querySelector('.page-wrapper'); if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---- price-pop re-key ------------------------------------------------ */
  P7.pop = function (el, text) {
    if (!el) return;
    if (text !== undefined) el.textContent = text;
    el.classList.remove('price-pop'); void el.offsetWidth; el.classList.add('price-pop');
  };
  P7.money = function (cents, format) {
    var n = cents / 100;
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    return (format || '$') + s;
  };
  P7.arrivalWindow = function () {
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var a = new Date(); a.setDate(a.getDate() + 6); var b = new Date(); b.setDate(b.getDate() + 10);
    return fmt(a) + ' – ' + fmt(b);
  };

  // Horizon scrolls `.page-wrapper` (not the window) at >=990px; use this for scroll listeners.
  P7.scroller = function () { return document.querySelector('.page-wrapper') || window; };
  P7.onScroll = function (fn) { window.addEventListener('scroll', fn, { passive: true }); var pw = document.querySelector('.page-wrapper'); if (pw) pw.addEventListener('scroll', fn, { passive: true }); };
  P7.init = function (root) { initStagger(root); initReveal(root); initSplit(root); initInk(root); initCounter(root); initTilt(root); };
  function boot() { P7.init(document); initParallax(); document.querySelectorAll('[data-arrival]').forEach(function (el) { el.textContent = P7.arrivalWindow(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Re-run for section-rendered / editor-injected content.
  document.addEventListener('shopify:section:load', function (e) { P7.init(e.target); });
  var mo = new MutationObserver(function (muts) { var need = false; muts.forEach(function (m) { if (m.addedNodes.length) need = true; }); if (need) { clearTimeout(P7._t); P7._t = setTimeout(function () { P7.init(document); }, 60); } });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });

  // Copy every contact form (wholesale, catering, contact) into the 787 CRM. Shopify still emails it; this is fire-and-forget.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.querySelector || !f.querySelector('input[name="form_type"][value="contact"]') || !navigator.sendBeacon) return;
    try { var d = new FormData(f); d.append('_page', location.href); navigator.sendBeacon('https://787-crm.vercel.app/api/inquiry', d); } catch (err) {}
  }, true);
})();
